/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class WorkActiveDaysRenderer
 *
 * @brief cell rendering for the list of active days.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class WorkActiveDaysRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: number[];

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui = document.createElement('div');
    this.gui.innerHTML = `<span style="color: grey;">Days...</span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    this.value = params?.value;

    if ((!this.value) || (typeof this.value === 'undefined')) {

      this.value = [];

      this.gui.innerHTML = `<span style="color: grey;">Days...</span>`;
      return ;
    }

    if (this.value.length === 0) {

      this.gui.innerHTML = `<span style="color: grey;">Days...</span>`;
      return ;
    }

    this.value.sort((a: number, b: number) => {

      return a - b;
    });

    let text: string = this.value.join(',');

    if (text.length >= 24) {

      text = text.substring(0, 24) + '...';
    }

    this.gui.innerHTML = `<span>${text}</span>`;

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
